<template >
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <v-layout column>
          <ModuelBase></ModuelBase>
          <v-flex>
            <v-card>
              <v-toolbar class="elevation-0" height="45" color="gray">
                <v-toolbar-title>
                  <h1 class="subheading">{{ $t("labels.invoiceEmail") }}</h1>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small color="pink" dark icon @click="invoiceEmail">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex class="font-weight-regular"><a @click="sendEmail(location.invoiceEmail)">{{
                      location.invoiceEmail
                    }}</a></v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card>
              <v-toolbar class="elevation-0" height="45" color="gray">
                <v-toolbar-title>
                  <h1 class="subheading">Recurly</h1>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small color="green" dark icon @click="recurlyView">
                  <v-icon small>mdi-eye-outline</v-icon>
                </v-btn>
                <v-btn small color="pink" dark icon @click="changeRecurly" v-if="checkRightStatus(25)">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="location.recurlyID">
                <v-layout column justify-center>
                  <v-layout row wrap>
                    <v-flex class="font-weight-regular">
                      <v-tooltip class="ml-1 pointer" bottom><template slot="activator"><a @click="openRecurly">{{
                        location.recurlyID }}
                          </a></template><span>View on recurly</span></v-tooltip>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="removeRecurlyID">
                      <v-icon color="blue-grey lighten-3">delete</v-icon>
                    </v-btn>
                  </v-layout>
                </v-layout>
              </v-card-text>
              <v-card-text v-else><span class="body-2 font-italic text-teal">Recurly ID Not Set</span></v-card-text>
              <v-card-text v-if="location.recurlyID" class="pa-2"><v-btn @click="getLink" color="success" block>Generate
                  Payment
                  Link</v-btn></v-card-text>
            </v-card>
          </v-flex>
          <!-- <v-flex>
            <v-card>
              <v-toolbar class="elevation-0" height="45" color="gray">
                <v-toolbar-title>
                  <h1 class="subheading">{{ $t("labels.stripe") }}</h1>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small color="pink" dark icon @click="changeStripe" v-if="checkRightStatus(25)">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="location.stripeID">
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex class="font-weight-regular">
                      <v-tooltip class="ml-1 pointer" bottom><template slot="activator"><a @click="openStripe">{{
                        location.stripeID }}
                          </a></template><span>View on stripe</span></v-tooltip>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="removeCard">
                      <v-icon color="blue-grey lighten-3">delete</v-icon>
                    </v-btn>
                  </v-layout>
                </v-layout>
              </v-card-text>
              <v-card-text v-else><span class="body-2 font-italic text-teal">Stripe Not Set</span></v-card-text>
            </v-card>
          </v-flex> -->
          <!-- <v-flex>
            <credit-card :stripeID="location.stripeID"></credit-card>
          </v-flex> -->
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md8>
        <v-tabs slider-color="info" right align-with-title v-model="active">
          <v-tab class="text-transform-none">{{ $t("labels.invoices") }}</v-tab>
          <v-tab class="text-transform-none">{{
            $t("labels.deletedInvoice")
          }}</v-tab>
          <v-tabs-items touchless>
            <v-tab-item lazy>
              <ListByStore></ListByStore>
            </v-tab-item>
            <v-tab-item lazy>
              <ListByStoreDeleted></ListByStoreDeleted>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-dialog v-model="paymentDialog" persistent width="500">

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Update Payment Method
        </v-card-title>

        <v-card-text>

          <div class="b black darken-2 text-center pa-3 white--text">
            {{ paymentLink }}
            <!-- <span class="white--text text-wrap">{{ paymentLink }}</span> -->
          </div>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="copyCode(paymentLink)">
            Copy
          </v-btn>
          <v-btn color="green" dark text @click="sendLinkEmail()">
            Email
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="paymentDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import locationService from '../service.js';
import recurlyService from '@/modules/Location/recurly.js';

const ListByStore = () => import('../../Invoice/components/ListByStore');
const ModuelBase = () => import('./components/ModuleBase');
const ListByStoreDeleted = () => import('../../Invoice/components/ListByStoreDeleted');
const CreditCard = () => import('./CreditCard');

export default {
  data() {
    return {
      loading: false,
      active: null,
      paymentLink: null,
      paymentDialog: false,
      recurlyAccount: null,
      subList: null,
      emailBody: null,
    };
  },
  computed: {
    ...mapGetters('location', ['location', 'organization', 'service']),
    ...mapGetters('global', ['checkRightStatus']),
  },
  methods: {
    ...mapActions('global', ['sendEmail']),
    ...mapActions('location', ['setLocation']),
    sendLinkEmail() {
      console.log('sendLinkEmail running')
      // this.sendEmail({
      //   address: this.organization.primaryEmail,
      //   subject: 'Update Your Payment Method',
      //   body: this.emailBody,
      // })
      // emailAddress: this.organization.loginEmail,
      //   subject: "Password for test email",
      //   password: this.organization.loginPassword,
      //   ownerName: this.organization.ownerName,
      //   loginEmail: this.organization.loginEmail,
      const data = {
        emailAddress: this.organization.primaryEmail,
        subject: 'Update Your Payment Method',
        paymentLink: this.paymentLink,
        ownerName: this.organization.ownerName,
      };

      
      locationService.sendPaymentUpdateLink(data).then((result) => {
        if (result.status) {
          this.$swal(
            'Payment Link!',
            `Payment link was send to to ${this.organization.loginEmail}.`,
            "success"
          );
        }
      });
    },
    async getLink() {
      this.paymentLink = "https://quiltsoftware.recurly.com/account"
      try {
        const recurly = await this.getRecurlyAccount(this.location.recurlyID)
        console.log('recurlyrecurlyrecurly', recurly)
        this.recurlyAccount = recurly
        this.paymentLink = `https://quiltsoftware.recurly.com/account/${this.recurlyAccount.hostedLoginToken}`
        this.paymentDialog = !this.paymentDialog

        // this.getRecurlyAccount(this.location.recurlyID)
      } catch (error) {
        console.log('error.message', error.message)
        const Toast = this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });

        Toast.fire({
          type: 'error',
          title: error.message,
        });
      }

      // this.$swal({
      //   title: 'Account',
      //   text: "You won't be able to revert this!",
      //   type: 'question',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'Copy',
      //   cancelButtonText: 'close',
      // }).then(() => {
      //   this.$Progress.finish();
      // });
    },
    getDayBalanceCount(startDate, endDate) {
      const startMoment = this.$moment(startDate);
      const endMoment = this.$moment(endDate);

      // Calculate the difference in days, including the start date
      const dayDifference = endMoment.diff(startMoment, 'days') + 1;

      return dayDifference;
    },
    copyCode(code) {
      // const copyText = code
      // console.log('copyText', copyText.innerHTML);
      console.log('location', this.location)
      navigator.clipboard.writeText(code);
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        type: "success",
        title: "Payment link was copy",
      });
      // this.$toast.success("Location code was copy", { timeout: 2000 });
    },
    openRecurly() {
      window.open(
        `https://quiltsoftware.recurly.com/accounts/${this.location.recurlyID}`,
        '_blank',
      );
    },
    openStripe() {
      window.open(
        `https://dashboard.stripe.com/customers/${this.location.stripeID}`,
        '_blank',
      );
    },
    removeRecurlyID() {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove it!',
      }).then((result) => {
        if (result.value) {
          this.$Progress.start();
          this.updateStore({
            recurlyID: null,
          }).then((result) => {
            if (result.data) {
              this.$swal(
                'ID Remove',
                'Recurly id was remove successfully.',
                'success',
              );
              this.setLocation(this.location.recurlyID);
              // this.getList()
            }
          });
        }
        this.$Progress.finish();
      });
    },
    removeCard() {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove it!',
      }).then((result) => {
        if (result.value) {
          this.$Progress.start();
          this.updateStore({
            stripeID: null,
          }).then((result) => {
            if (result.data) {
              this.$swal(
                'Stripe!',
                'Stripe id was remove successfully.',
                'success',
              );
              this.setLocation(this.location.storeID);
              // this.getList()
            }
          });
        }
        this.$Progress.finish();
      });
    },
    updateStore(data) {
      return locationService
        .updateStore(this.location.storeID, data)
        .then((result) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });

          Toast.fire({
            type: 'success',
            title: 'Update Successfully',
          });
          this.setLocation(this.location.storeID);
          return result;
        });
    },
    async getRecurlyAccount(id) {
      try {
        const account = await recurlyService.getAccount(id)
        // console.log('Fetched account: ', account)
        if (account.length !== 0) {
          return account
        }
        throw new Error('Account No Found!')
      } catch (error) {
        throw error
      }
      // return recurlyService
      //   .getAccount(id)
      //   .then((result) => {
      //     console.log('recurly getAccount', result)
      //     console.log('recurly getSubByAccount', result)
      //     if (result) {
      //       return result;
      //     }
      //     throw new Error('Account No Found!')
      //     // return result;
      //   });
    },
    async recurlyView() {
      this.recurlyAccount = await this.getRecurlyAccount(this.location.recurlyID)
      console.log('RecurlyAccount', this.recurlyAccount)
      let data = {
        softwareAlert: false,
        softwareAlertNotes: null,
        alertUrl: null,
        alertColor: null,
      };
      if (this.recurlyAccount && this.recurlyAccount.hasActiveSubscription && this.recurlyAccount.hasPastDueInvoice) {
        console.log('set the message')
        // this.paymentLink = "https://quiltsoftware.recurly.com/account"
        this.paymentLink = `https://quiltsoftware.recurly.com/account/${this.recurlyAccount.hostedLoginToken}`
        data = {
          softwareAlert: true,
          softwareAlertNotes: 'This account is Past Due.',
          alertUrl: this.paymentLink,
          alertColor: 'warning',
        };
      }
      console.log('teset account', data)
      this.updateStore(data);

      // await recurlyService
      //   .getSubByAccount(this.location.recurlyID)
      //   .then((result) => {
      //     console.log('recurly getSubByAccount', result)
      //     if (result) {
      //       // console.log('getDayBalanceCount', result[0].currentPeriodStartedAt, result[0].currentPeriodEndsAt)
      //       // const dayBalanceCount = this.getDayBalanceCount(result[0].currentPeriodStartedAt, result[0].currentPeriodEndsAt);
      //       // console.log('dayBalanceCount', dayBalanceCount)
      //       this.subList = result
      //       return result;
      //     }
      //     throw new Error('Account No Found!')
      //   });

      // if (this.subList) {
      //   this.getInvoice(this.subList[0].activeInvoiceId)
      // }

      // return recurlyService
      //   .getInvoiceByAccount(this.location.recurlyID)
      //   .then((result) => {
      //     console.log('recurly getInvoiceByAccount', result)
      //     return result;
      //   });
    },
    getInvoice(id) {
      return recurlyService
        .getInvoice(id)
        .then((result) => {
          console.log('recurly Invoice', result)
          return result;
        });
    },
    async changeRecurly() {
      const { value: recurlyID } = await this.$swal.fire({
        title: 'Enter Recurly ID',
        input: 'text',
        showCancelButton: true,
        inputPlaceholder: 'Enter new recurly id',
      });

      if (recurlyID) {
        console.log('recurlyID', recurlyID)
        try {
          const recurly = await this.getRecurlyAccount(recurlyID)
          console.log('recurlyrecurlyrecurly', recurly)
          this.updateStore({
            recurlyID,
          });
        } catch (error) {
          console.log('error.message', error.message)
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });

          Toast.fire({
            type: 'error',
            title: error.message,
          });
        }
      }
    },
    async changeStripe() {
      const { value: stripeID } = await this.$swal.fire({
        title: 'Enter Stripe ID',
        input: 'text',
        showCancelButton: true,
        inputPlaceholder: 'Enter new stripe id',
      });

      if (stripeID) {
        this.updateStore({
          stripeID,
        });
      }
    },
    async invoiceEmail() {
      const { value: email } = await this.$swal.fire({
        title: 'Invoice Email',
        input: 'email',
        showCancelButton: true,
        inputPlaceholder: 'Enter New Email Address',
      });

      if (email) {
        this.updateStore({
          invoiceEmail: email,
        });
        // this.$swal.fire('Entered email: ' + email)
      }
    },
  },
  components: {
    ListByStore,
    ModuelBase,
    CreditCard,
    ListByStoreDeleted,
  },
};
</script>

<style scoped>
div.b {
  word-wrap: break-word;
}
</style>
